export const columns = [
  {
    label: "Policy #",
    field: "policy_number",
    sort: "asc",
  },
  {
    label: "Insurance Company",
    field: "insurance_company",
    sort: "asc",
  },
  {
    label: "Insured",
    field: "insured",
    sort: "asc",
  },
  {
    label: "Class Of Business",
    field: "cob",
    sort: "asc",
  },
  {
    label: "Sum Insured",
    field: "sum_insured",
    sort: "asc",
  },
  {
    label: "Rate",
    field: "rate",
    sort: "asc",
  },
  {
    label: "Status",
    field: "offer_status",
    sort: "asc",
  },
  {
    label: "Offer Date",
    field: "offer_date",
    sort: "asc",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "asc",
  },
];

export const tableColumns = [
  {
    Header: "Policy #",
    accessor: "policy_number",
    // sort: "asc",
  },
  {
    Header: "Insurance Company",
    accessor: "insurance_company",
    // sort: "asc",
  },
  {
    Header: "Insured",
    accessor: "insured",
    // sort: "asc",
  },
  {
    Header: "Class Of Business",
    accessor: "cob",
    // sort: "asc",
  },
  {
    Header: "Sum Insured",
    accessor: "sum_insured",
    // sort: "asc",
  },
  {
    Header: "Rate",
    accessor: "rate",
    // sort: "asc",
  },
  {
    Header: "Status",
    accessor: "offer_status",
    // sort: "asc",
  },
  {
    Header: "Offer Date",
    accessor: "offer_date",
    // sort: "asc",
  },
  {
    Header: "Actions",
    accessor: "actions",
    // so
  }
]
